import {API_HOST, AXIOS_INSTANCE} from './api'
import axios from 'axios'

const DOCUMENT_ENDPOINT = "documents";

export async function GET_DOCUMENT(kit, type = null, document = null) {
  const response = await AXIOS_INSTANCE.get(`${API_HOST}/${DOCUMENT_ENDPOINT}/${kit}`, {
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('token')
    }
  });
  return response.data;
}



// WEBPACK FOOTER //
// ./src/services/document.js